(function () {
  'use strict';

  var MIN_LENGTH = 2;
  var DEBOUNCE_MS = 180;
  var RESULT_LIMIT = 4;

  function makeElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }

  function formatPrice(value) {
    var cents = Math.round(Number(value) * 100);
    if (!Number.isFinite(cents) || !window.Shopify || !Shopify.formatMoney) return '';
    return Shopify.formatMoney(cents, window.money_format);
  }

  function imageUrl(image) {
    if (!image || !image.url) return '';
    try {
      var url = new URL(image.url, window.location.origin);
      if (url.protocol !== 'https:') return '';
      url.searchParams.set('width', '112');
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function searchUrl(form, query) {
    var url = new URL(form.action, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url.toString();
  }

  function initForm(form) {
    if (form.dataset.lmSearchReady === 'true') return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    form.dataset.lmSearchReady = 'true';
    form.classList.add('lm-search');
    input.setAttribute('aria-label', 'Buscar productos');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('enterkeyhint', 'search');

    var clear = makeElement('button', 'lm-search__clear');
    clear.type = 'button';
    clear.setAttribute('aria-label', 'Borrar búsqueda');
    clear.hidden = !input.value;
    var clearIcon = makeElement('i', 'flaticon-cancel');
    clearIcon.setAttribute('aria-hidden', 'true');
    clear.appendChild(clearIcon);

    var panel = makeElement('div', 'lm-search__panel');
    panel.hidden = true;
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-label', 'Sugerencias de búsqueda');
    var heading = makeElement('p', 'lm-search__heading', 'Productos');
    var list = makeElement('ul', 'lm-search__list');
    var message = makeElement('p', 'lm-search__message');
    message.hidden = true;
    var more = makeElement('a', 'lm-search__more');
    panel.appendChild(heading);
    panel.appendChild(list);
    panel.appendChild(message);
    panel.appendChild(more);

    var status = makeElement('span', 'lm-search__status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    input.insertAdjacentElement('afterend', clear);
    form.appendChild(panel);
    form.appendChild(status);

    var timer;
    var request;
    var sequence = 0;
    var suppressFocusSearch = false;

    function close() {
      panel.hidden = true;
    }

    function cancel() {
      clearTimeout(timer);
      sequence += 1;
      if (request) request.abort();
      request = null;
    }

    function showMessage(text, query) {
      list.replaceChildren();
      heading.hidden = true;
      more.hidden = !query;
      if (query) {
        more.href = searchUrl(form, query);
        more.textContent = 'Ver todos los resultados de “' + query + '”';
      }
      message.textContent = text;
      message.hidden = false;
      panel.hidden = false;
    }

    function render(products, query) {
      list.replaceChildren();
      if (!products.length) {
        showMessage('No encontramos sugerencias para esta búsqueda.', query);
        status.textContent = 'No hay sugerencias. Puedes buscar todos los resultados.';
        return;
      }

      products.forEach(function (product) {
        var item = makeElement('li', 'lm-search__item');
        var link = makeElement('a', 'lm-search__result');
        link.href = product.url;
        var src = imageUrl(product.featured_image);
        if (src) {
          var image = makeElement('img', 'lm-search__image');
          image.src = src;
          image.alt = '';
          image.width = 56;
          image.height = 56;
          image.loading = 'lazy';
          image.decoding = 'async';
          link.appendChild(image);
        } else {
          link.appendChild(makeElement('span', 'lm-search__image lm-search__image--empty'));
        }
        var details = makeElement('span', 'lm-search__details');
        details.appendChild(makeElement('span', 'lm-search__title', product.title));
        var price = formatPrice(product.price);
        if (price) details.appendChild(makeElement('span', 'lm-search__price', price));
        if (!product.available) details.appendChild(makeElement('span', 'lm-search__sold-out', 'Agotado'));
        link.appendChild(details);
        item.appendChild(link);
        list.appendChild(item);
      });

      heading.hidden = false;
      message.hidden = true;
      more.hidden = false;
      more.href = searchUrl(form, query);
      more.textContent = 'Ver todos los resultados de “' + query + '”';
      panel.hidden = false;
      status.textContent = products.length + (products.length === 1 ? ' sugerencia de producto.' : ' sugerencias de productos.');
    }

    function fetchResults(query, currentSequence) {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      var url = new URL('search/suggest.json', window.location.origin + root);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', String(RESULT_LIMIT));
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      request = new AbortController();
      showMessage('Buscando productos…');

      fetch(url.toString(), { signal: request.signal, credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (data) {
          if (currentSequence !== sequence || input.value.trim() !== query) return;
          var products = data.resources && data.resources.results && data.resources.results.products || [];
          render(products, query);
        })
        .catch(function (error) {
          if (error.name === 'AbortError' || currentSequence !== sequence) return;
          showMessage('No pudimos cargar sugerencias. Puedes ver todos los resultados.', query);
          status.textContent = 'No pudimos cargar sugerencias.';
        });
    }

    function schedule() {
      cancel();
      var query = input.value.trim();
      clear.hidden = !query;
      if (query.length < MIN_LENGTH) {
        close();
        status.textContent = '';
        return;
      }
      close();
      var currentSequence = sequence;
      timer = setTimeout(function () { fetchResults(query, currentSequence); }, DEBOUNCE_MS);
    }

    input.addEventListener('input', schedule);
    input.addEventListener('focus', function () {
      if (suppressFocusSearch) {
        suppressFocusSearch = false;
        return;
      }
      schedule();
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        cancel();
        close();
      } else if (event.key === 'ArrowDown' && !panel.hidden) {
        var first = list.querySelector('a') || more;
        if (first && !first.hidden) {
          event.preventDefault();
          first.focus();
        }
      }
    });
    panel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        suppressFocusSearch = true;
        input.focus();
        close();
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        var links = Array.from(panel.querySelectorAll('a')).filter(function (link) { return !link.hidden; });
        var index = links.indexOf(document.activeElement);
        if (index < 0) return;
        event.preventDefault();
        var next = index + (event.key === 'ArrowDown' ? 1 : -1);
        if (next < 0) input.focus();
        else if (next < links.length) links[next].focus();
      }
    });
    clear.addEventListener('click', function () {
      input.value = '';
      cancel();
      close();
      clear.hidden = true;
      status.textContent = '';
      input.focus();
    });
    form.addEventListener('submit', cancel);
    document.addEventListener('pointerdown', function (event) {
      if (!form.contains(event.target)) close();
    });
    form.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!form.contains(document.activeElement)) close();
      }, 0);
    });
  }

  function init(root) {
    root.querySelectorAll('form.searchform[role="search"]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
